/* eslint no-unused-vars: 'off' */
import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import analysis from '@/components/analysis'
import validateVariables from '@/components/validateVariables'
import validateLevels from '@/components/validateLevels'
import getApi from '@/components/getApi'

import ctRoutes from '@/router/ctRoutes';
import lrRoutes from '@/router/lrRoutes';
import userGuideRoutes from './userGuideRoutes';

Vue.use(Router);

//Vue.component('lr-navigation-buttons', CtNavigationButtons)


export default new Router({
    routes: getRoutes()
    //beforeRouteEnter(to, from, next) {
    //  console.log('beforeRouteLeave');
    //},
    //beforeRouteUpdate(to, from, next) {
    //  console.log('beforeRouteLeave');
    //},
    //beforeRouteLeave(to, from, next) {
    //  console.log('beforeRouteLeave');
    //}
});

function getRoutes() {
    const otherRoutes = [
        {
            path: '/',
            name: 'index',
            component: index
        },
        { path: '/analysis', name: 'analysis', component: analysis },
        { path: '/validateVariables', name: 'validateVariables', component: validateVariables },
        { path: '/validateLevels', name: 'validateLevels', component: validateLevels },
        { path: '/getApi', name: 'getApi', component: getApi },

    ];
    const allRoutes = [
        ...ctRoutes.routes,
        ...lrRoutes.routes,
        ...userGuideRoutes.routes,
        ...otherRoutes];
    return allRoutes;
}